import { render, staticRenderFns } from "./CreateServiceType.vue?vue&type=template&id=92b7f662&scoped=true&"
import script from "./CreateServiceType.vue?vue&type=script&lang=js&"
export * from "./CreateServiceType.vue?vue&type=script&lang=js&"
import style0 from "./CreateServiceType.vue?vue&type=style&index=0&id=92b7f662&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b7f662",
  null
  
)

export default component.exports